// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"4c59ff87","453":"443a2595","864":"0bd64f87"}[chunkId] + ".chunk.js";
};